export default __webpack_public_path__ + "6a7828f92c91da2717943834b022f6f2.png";